import { render, staticRenderFns } from "./AddLocal.vue?vue&type=template&id=525329ee&"
import script from "./AddLocal.vue?vue&type=script&lang=js&"
export * from "./AddLocal.vue?vue&type=script&lang=js&"
import style0 from "./AddLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports